import i18n from '#helpers/i18n/i18n.js'
import swal from '#helpers/sweetalert/sweetalert.js'

/**
 * Show an alert with an 'error' icon to confirm something went wrong.
 * Disappears automatically.
 * @param {string|undefined} [text] The text to display
 * @returns {Promise} A Promise that resolves/rejects after the alert is shown
 */
export default async function showError(text) {
	return swal({
		className: 'shadow-dreamy',
		icon: 'error',
		text: text ?? i18n.global.t('alerts.error'),
		buttons: false,
	})
}
